import React, { useState } from 'react';
import { api } from '../../../../redux/setupAxios';
import { Switch } from "@material-ui/core"
import { useSelector, shallowEqual } from 'react-redux';

const Plan = props => {
	const { selected, pricePlan, PLANS, merchantPaymentPlan, billingInterval } = props;
	const [isAnnualy, setIsAnnualy] = useState(!billingInterval ? true : billingInterval === 'ANNUAL');
	const merchant = useSelector(state => state.merchants.merchants, shallowEqual)[0];
	const plan = PLANS[selected];
	const handleSubscription = plan => async () => {
		const pricePlanToSend = {
			...pricePlan,
			pricing: {
				[selected]: getPrice() * (isAnnualy ? 12 : 1),
			},
			interval: isAnnualy ? 'ANNUAL' : 'EVERY_30_DAYS',
			trial: 0,
		}
		const { data } = await api.post('shopify/create-subscription', { plan, pricePlan: pricePlanToSend });
		if (data) {
			window.location.href = data;
		}
	};

	const onCycleChange = (e) => {
		setIsAnnualy(e.target.checked)
	}

	const getPrice = () => {
		const origPrice = isAnnualy ? pricePlan.pricing[selected] : pricePlan.pricing[selected] * 1.2;
		return (Math.round(origPrice * 100) / 100).toFixed(2);
	}
	const disableButton = merchantPaymentPlan?.plan.toLowerCase() === selected.toLowerCase() &&
		pricePlan.monthlySessions === parseInt(merchant?.monthlySessions) &&
		isAnnualy === (billingInterval === 'ANNUAL');
	const showContactUs = pricePlan.pricing[selected] === 'CONTACTUS';
	return (
		<div className='plan-modal'>
			<div className='card w-100 rounded-0 right-panel'>
				<div>
					<div className='d-flex header-wrapper'>
						<h3>Summary</h3>
						<div className='btn btn-sm btn-icon' id='kt_drawer_plan_close'>
							{/* <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' /> */}
						</div>
					</div>
					<div className='plan-details'>
						<span className='title-plan fs-4 fw-bold'>Plan</span>
						<span className='fs-5 monthly' style={{ textTransform: 'capitalize' }}>
							{selected} {pricePlan.monthlySessions} Sessions a month
						</span>
					</div>
					<div className='billing-wrapper'>
						<span className='title-plan fs-4 fw-bold'>Billing cycle</span>
						<div>
							<span className='fs-5 monthly'>Monthly</span>
							<Switch checked={isAnnualy} onChange={onCycleChange} />
							<span className='fs-5 monthly'>Annualy (save 20%)</span>
						</div>
					</div>
					{!showContactUs && (
						<div>
							<span className='title-plan fs-4 fw-bold'>Price</span>
							<span className='price-title fs-1 fw-bold'>
								<span className='fs-6 monthly'> {'$' + getPrice()} per month</span>
								{isAnnualy &&
									<div className='fs-6 monthly'> {'$' + new Intl.NumberFormat('en-US').format(getPrice() * 12)} per year</div>
								}
							</span>
						</div>
					)}
				</div>
				<div className='btn-wrapper'>
					{showContactUs ? (
						<button
							type='button'
							className='btn btn-orange'
							href='mailto:contact@squadded.com'
							onClick={() => window.open('mailto:contact@squadded.com')}
						>
							Contact Us
						</button>
					) : (
						<button
							disabled={disableButton}
							type='button'
							className='btn btn-orange'
							href='#/'
							onClick={handleSubscription(plan)}
						>
							{disableButton ? 'Your current plan' : 'Checkout'}
						</button>
					)}
					<span className='monthly'>
						Need additional information? <a href='#/'>Learn more</a>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Plan;
